/**
 * ご家族向けの問診票画面
 */
import { Component, ViewChild, ElementRef } from "@angular/core";
import {
  NavController,
  NavParams,
  Content,
  AlertController,
  Platform,
  ViewController,
  ToastController,
  ModalController,
} from "ionic-angular";
import { PhotoLibrary } from "../../../../providers/my-photo-library";
import { PhotoViewer } from "@ionic-native/photo-viewer";
import { CallNumber } from "@ionic-native/call-number";
import { AbstractPage } from "../../../_com/abstract-page";
import { ChatAction } from "../../../../actions/chat.action";
import { ReserveAction } from "../../../../actions/reserve.action";
import _ from "underscore";
import moment from "moment";
import { HoikuchuFukajikoModalPage } from "../../../_com/hoikuchu-fukajiko-modal/hoikuchu-fukajiko-modal";

/**
 * Generated class for the ReserveDetailPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: "page-reserve-interview-edit-family",
  templateUrl: "reserve-interview-edit-family.html",
})
export class InterviewSheetEditFamilyPage extends AbstractPage {
  // 予約情報
  // - サンプル
  // {"datetime":{"input":{"date":"2022-02-14T01:12:07.000Z","time":["2022-02-08T01:00:00.000Z","2022-02-08T05:00:00.000Z"]},"elapsed":{"h":4,"m":"00"},"date":"2022-02-14","time":["10:00","14:00"]},"family":{"id":"61127004a63367be6a543a9e","data":{"Family":{"name":"テストお名前","kana":"テストデータ","tel":"012-3456-789","type":"other","mail_address":"ryo.fujiwara@brightvie.me","zip":1234567,"address":"愛知県名古屋市","sns_keisai_status":"true","photo_uketori_status":"true","modified_user":"5ad6ab64a63367582f40221c","modified":"2022-Feb-13 07:56:43","created":"2021-Aug-10 21:24:36","children":["61127020a63367c06a543a94","614fdedaa63367da2e54941a"],"reset_token":null,"name2":"あああ","tel2":"012-3456-789","tel2_relation":"夫","id":"61127004a63367be6a543a9e"}}},"pickup":{"elapsed_time":"1","pickup_Name":"テストお名前","pickup_Name_kana":"テストデータ","tel":"0123456789","relation":"","type":"1","pickup_time":"2022-02-08T05:00:00.000Z"},"children":[{"id":"61127020a63367c06a543a94","childOfAge":[5,10],"data":{"Child":{"familyId":"61127004a63367be6a543a9e","newChild":false,"name":"太郎","kana":"たろう","gender":"boy","birthday":"2016-03-23T15:00:00.000Z","takuji_keiken_status":"true","allergy_status":"true","sikkan":"true","junyu_status":"false","modified_user":"5ad6ab64a63367582f40221c","modified":"2022-Feb-13 09:36:16","created":"2021-Aug-10 21:25:03","tabetakotoaru_foods":["3","4","5"],"keijyo_yasai":"3","rinyushoku_shokuzai":["jagaimo","ninjin","aona","tamanegi","kyabetsu"],"rinyushoku_tabetakotoaru_shokuzai":["jagaimo","ninjin","aona","kyabetsu","shoyu"],"rinyusyoku_okayu":"5","syokuji_ryo":"2","syokuji_kininaru_tabemura":true,"syokuji_kininaru_asobitabe":true,"seikatsu_rizumu_kisho":"2021-09-26T03:00:00.000Z","sanpo_sanka_status":"true","allergy_text":"2/10 あいうえお","sikkan_sonota_text":"2/10 かきくけこ","konamiruku_text":"2/10 さしすせそ","id":"61127020a63367c06a543a94"}}}],"memoToStaff":"","consent":true,"status":0,"reserve_request_date":"2022/02/08 10:13:00","type":"other","modified":"2022-Feb-08 17:19:48","created":"2022-Feb-08 10:13:00","id":"6201c39ce2accf064ee6d4ca"}
  reserve: any = {};
  // 家族情報
  // - サンプル
  // {"id":"61127004a63367be6a543a9e","data":{"Family":{"name":"テストお名前","kana":"テストデータ","tel":"012-3456-789","type":"other","mail_address":"tech@mail","zip":1234567,"address":"愛知県名古屋市","sns_keisai_status":"true","photo_uketori_status":"true","modified_user":"5ad6ab64a63367582f40221c","modified":"2022-Feb-13 07:56:43","created":"2021-Aug-10 21:24:36","children":["61127020a63367c06a543a94","614fdedaa63367da2e54941a"],"reset_token":null,"name2":"あああ","tel2":"012-3456-789","tel2_relation":"夫","id":"61127004a63367be6a543a9e"}}}
  family: any = {};
  // 子供情報
  // - サンプル
  // {"Child":{"familyId":"61127004a63367be6a543a9e","newChild":false,"name":"太郎","kana":"たろう","gender":"boy","birthday":"2016-03-23T15:00:00.000Z","takuji_keiken_status":"true","allergy_status":"true","sikkan":"true","junyu_status":"false","modified_user":"5ad6ab64a63367582f40221c","modified":"2022-Feb-13 09:36:16","created":"2021-Aug-10 21:25:03","tabetakotoaru_foods":["3","4","5"],"keijyo_yasai":"3","rinyushoku_shokuzai":["jagaimo","ninjin","aona","tamanegi","kyabetsu"],"rinyushoku_tabetakotoaru_shokuzai":["jagaimo","ninjin","aona","kyabetsu","shoyu"],"rinyusyoku_okayu":"5","syokuji_ryo":"2","syokuji_kininaru_tabemura":true,"syokuji_kininaru_asobitabe":true,"seikatsu_rizumu_kisho":"2021-09-26T03:00:00.000Z","sanpo_sanka_status":"true","allergy_text":"2/10 あいうえお","sikkan_sonota_text":"2/10 かきくけこ","konamiruku_text":"2/10 さしすせそ","id":"61127020a63367c06a543a94"}}
  child: any = {};

  interviewId = "";

  // 問診票の型定義と初期値の設定
  interviewInfo: {
    // - 新型コロナウィルス感染防止に関するお願い への同意
    agreemented: boolean;
    // - 新型コロナウィルス感染防止に関するお願い にてマスク着用への同意
    agreementedMask: boolean;
    // - 離乳食の進み具合: ご飯(F:普通のご飯/N:軟飯/5/7/10)
    rinyusyoku_okayu?: string;
    // - 離乳食の進み具合: 野菜などの形状 (1:幼児食...~ 5:初期（すりおろし）)
    keijyo_yasai?: string;
    rinyushoku_tabetakotoaru_shokuzai?: string[],
    // - アレルギーの変更点
    is_change_allergy_status?: "change" | "";
    allergy_status?: "true" | "false" | ""; // NOTE: あえて文字列で定義しているっぽい(最初の作りから
    change_allergy_text?: string;
    // -今回新たに食べられるようになった食材（任意）
    tabetakotoaru_foods?: string[];
    // - 保育中の不可事項
    other_questions?: string;

    // - 授乳
    breastfeed?: "true" | "false"; // NOTE: あえて文字列で定義しているっぽい(最初の作りから
    // - 園内の水分摂取の確認事項
    breastfeed_confirmed?: boolean;
    // - 授乳:・最終授乳時間 時間から選択
    breastfeed_lasttime?: string;
    // - 授乳:・預かり中予定時間 時間から選択
    breastfeed_nexttime?: string;
    // - 園内の粉ミルクの種類
    //   園内の粉ミルク / 持参の粉ミルク / 冷凍母乳 / 母乳
    breastfeed_type?: string;

    // - 授乳:・飲む量　１回（　　）cc
    //   - ※ 園内の粉ミルク / 持参の粉ミルク にチェックがある場合のみ
    breastfeed_drinkcc?: string;

    // お子様が持参の粉ミルクを飲めなかった場合の対応
    // - 園内の粉ミルク / call
    breastfeed_cannotdrink?: string;

    // - 連絡事項(自由記入欄)
    breastfeed_memo?: string;

    // 確認事項のチェックリスト
    // ミルクの持ち込む際の確認事項
    // - 粉ミルクは1回分ごとに個装し、氏名を記入しましたか？
    breastfeedMyMilkConfirmed001?: boolean,
    // - 粉ミルクは賞味期限内のものですか？
    breastfeedMyMilkConfirmed002?: boolean,

    // 冷凍母乳のチェックリスト
    //  - 専用の母乳バッグに氏名・搾乳日時を記入しましたか？
    breastfeedFrozenBreastMilkConfirmed001?: boolean,
    // - 搾乳器を使用した場合は、消毒を行ったもので搾乳しましたか？
    breastfeedFrozenBreastMilkConfirmed002?: boolean,
    // - 搾乳後すぐに冷凍庫にて保管しましたか？
    breastfeedFrozenBreastMilkConfirmed003?: boolean,
    // - 搾乳後 1 週間以内のものを凍ったまま持参しましたか？
    breastfeedFrozenBreastMilkConfirmed004?: boolean,


    // - 怪我
    injured?: "true" | "false"; // NOTE: あえて文字列で定義しているっぽい(最初の作りから
    injurd_description?: string;
    // - お昼寝
    napped?: "true" | "false"; // NOTE: あえて文字列で定義しているっぽい(最初の作りから
    nap_description?: string;
    // - 与薬
    use_drug?: "true" | "false"; // NOTE: あえて文字列で定義しているっぽい(最初の作りから)
    use_drug_description?: string;
    // ** 服薬書 **
    // - 薬剤処方日: YYYY-MM-DDの形式
    drug_prescription_date?: string;

    // - 医療機関名
    drug_hospital_name?: string;
    // - 薬情報
    drug_list: {
      name: string;
      what: string;
      what_other_description: string;
      when: string;
      when_other_description: string;
      how: string;
      how_other_description: string;
      external_description: string;
      description: string;
    }[];
    // - 与薬依頼日: YYYY-MM-DDの形式
    drug_use_requested_date?: string;
    // - 与薬依頼者(保護者名)
    drug_use_requester_name?: string;
    // ** ** **

    // - 予約時からの変更点
    change_description?: string;
    // - 入浴の希望有無 yes or no
    change_nyuyokukibou?: string;
    // - 特記事項
    notice?: string;
  } = {
    agreemented: false,
    agreementedMask: false,
    drug_list: [],
  };

  // 問診票のお薬関連の日付 (APIは文字列形式だが、ion-inputはDate型で管理するため)
  // - 薬剤処方日: YYYY-MM-DDの形式
  drugPrescriptionDate?: Date;
  // - 与薬依頼日: YYYY-MM-DDの形式
  drugUseRequestedDate?: Date;

  // api側に送るデータを定義
  data = {
    id: "",
    child: {},
    reserve: {},
    interviewInfo: {},
    reserve_request_date: "",
    created: "",
  };

  // カレンダー表示のパラメータ(親クラスのデータを上書き)
  mbscDateOptions: any = {
    display: "center",
    setOnDayTap: true,
    lang: "ja",
    animate: "fade",
    dateFormat: "yy/m/d(D)",
    firstSelectDay: 1,
    buttons: [],
    max: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate()
    ),
  };

  isDataExists = true; // 問診票データが存在するかどうか

  // ご家族の入力が終われば、スタッフがパスワードを入力して元の画面に戻る
  isStaffConfirm: boolean = false;
  staffPassword: string = "";


  breastfeed_lasttime = new Date();

  breastfeed_nexttime = new Date();



  @ViewChild(Content) content: Content;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertController: AlertController,
    private toastController: ToastController,
    private modalController: ModalController,
    private reserveAction: ReserveAction,
    private el: ElementRef,
    public chatAction: ChatAction,
    private pv: PhotoViewer,
    private pl: PhotoLibrary,
    private plt: Platform,
    private callNumber: CallNumber,
    public viewController: ViewController
  ) {
    super();
    // 予約情報
    this.reserve = this.navParams.data.reserve;
    // 家族情報
    this.family = this.navParams.data.reserve.family;


    if (this.navParams.data.isDetail) {
      // 予約詳細からきた場合
      this.child = this.navParams.data.child; // 子ども情報
      this.interviewInfo = this.navParams.data.interviewInfo; // 問診票情報

      if (this.interviewInfo.drug_prescription_date) {
        this.drugPrescriptionDate = new Date(
          this.interviewInfo.drug_prescription_date
        );
      }
      if (this.interviewInfo.drug_use_requested_date) {
        this.drugUseRequestedDate = new Date(
          this.interviewInfo.drug_use_requested_date
        );
      } else {
        // デフォルトは、預ける日付
        this.drugUseRequestedDate = new Date(this.reserve.reserve_request_date)
      }

      if (this.interviewInfo.breastfeed_lasttime) {
        this.breastfeed_lasttime = new Date(`${moment().format("YYYY/MM/DD")} ${this.interviewInfo.breastfeed_lasttime}`);
      }
      if (this.interviewInfo.breastfeed_nexttime) {
        this.breastfeed_nexttime = new Date(`${moment().format("YYYY/MM/DD")} ${this.interviewInfo.breastfeed_nexttime}`);
      }

      this.interviewId = this.navParams.data.interviewId; // 問診票ID

    } else {
      // 問診票詳細からきた場合
      this.child = this.navParams.data.child.Child; // 子ども情報
    }


    // 変更有無のチェック
    if (this.interviewInfo) {
      // 離乳食 ごはん
      if (this.interviewInfo?.rinyusyoku_okayu && this.child?.rinyusyoku_okayu !== this.interviewInfo.rinyusyoku_okayu) {
        this.isChangeRinyusyokuOkayuBox = "change";
      }
      // 離乳食 野菜
      if (this.interviewInfo?.keijyo_yasai && this.child?.keijyo_yasai !== this.interviewInfo.keijyo_yasai) {
        this.isChangeKeijyoYasaiBox = "change";
      }
      // 入浴希望
      if (this.interviewInfo?.change_nyuyokukibou) {
        this.isChangeNyuyokuKiboubox = "change";
      }
    }

    console.log(`予約`);
    console.log(this.reserve);
    console.log(`家族`);
    console.log(this.family);
    console.log(`子供`);
    console.log(this.child);
    console.log(`問診票`);
    console.log(this.interviewInfo);
    super.readyDomAccess(this.el);

    this.pl; //for TSLint
    this.pv; //for TSLint
    this.plt; //for TSLint
    this.callNumber; //for TSLint
  }


  onClickHoikuchuFukajikoModal() {
    let modal = this.modalController.create(HoikuchuFukajikoModalPage, {
      other_questions: this.interviewInfo.other_questions || []
    }, { enableBackdropDismiss: false });
    modal.onDidDismiss(data => {
      console.log(data);
      if (data && data.other_questions) {
        this.interviewInfo.other_questions = data.other_questions;
      }
    });
    modal.present();
  }

  ngOnInit() {  }

  /**
   * 画面が呼び出される前にロード
   */
  ionViewDidLoad() {
    // 受け取った値をセットする
  }

  /**
   * キャンセル処理
   */
  cancel() {
    //入力項目タッチ無し
    if (!this.hasTouched()) {
      this.isStaffConfirm = true;
      // this.viewController.dismiss();
      return;
    }

    //入力項目タッチありで、画面を閉じる
    this.confirm(
      this.alertController,
      "入力内容を破棄し、スタッフに端末を返却します。よろしいですか？",
      () => {
        this.isStaffConfirm = true;
        // this.viewController.dismiss();
      }
    );
  }

  showAlertMessage(text: string) {
    this.alert(this.alertController, text);
  }

  /**
   * 問診票情報保存
   */
  save() {

    // 新型コロナウィルス感染防止に関するお願いの確認
    if (!this.interviewInfo.agreemented || !this.interviewInfo.agreementedMask) {
      this.showAlertMessage("画面上部「新型コロナウィルス感染防止に関するお願い」に関する確認欄にチェックを入れてください。");
      return;
    }

    // 離乳食の形状 ご飯 変更あり
    if (this.isChangeRinyusyokuOkayuBox) {
      // requiredError: ご飯 変更ありの場合の変更値を入力
      if (!this.interviewInfo.rinyusyoku_okayu) {
        this.showAlertMessage("「離乳食の形状」に関する内容を入力してください。");
        return;
      }
    }

    // 離乳食の形状 野菜 変更あり
    if (this.isChangeKeijyoYasaiBox) {
      // requiredError: 野菜 変更ありの場合の変更値を入力
      if (!this.interviewInfo.keijyo_yasai) {
        this.showAlertMessage("「離乳食の形状」に関する内容を入力してください。");
        return;
      }

      if (!(this.interviewInfo.keijyo_yasai === '1' || this.interviewInfo.keijyo_yasai === '2')) {
        if (!this.interviewInfo.rinyushoku_tabetakotoaru_shokuzai) {
          this.showAlertMessage("「食べたことがある離乳食の食材」に関する内容を入力してください。");
          return;
        }
      }
    }


    // requiredError: 保育中の不可事項
    if (!this.interviewInfo.other_questions) {
      this.showAlertMessage("「保育中の不可事項」に関する内容を入力してください。");
      return;
    }

    // requiredError: 授乳
    if (!this.interviewInfo.breastfeed) {
      this.showAlertMessage("「授乳」に関する内容を入力してください。");
      return;
    } else if (this.interviewInfo.breastfeed === "true") {

      // requiredError: チェックの確認事項
      if (!this.interviewInfo.breastfeed_confirmed) {
        this.showAlertMessage("「お預かり中の授乳」の確認欄にチェックを入力してください。");
        return;
      }

      // 最後の授乳時間
      if (!this.breastfeed_lasttime) {
        this.showAlertMessage("授乳欄の「最後の授乳時間」に関する内容を入力してください。");
        return;
      } else {
        // 形式 "時:分" => HH:mm
        this.interviewInfo.breastfeed_lasttime = moment(this.breastfeed_lasttime).format("HH:mm");
      }
      // 預かり中予定時間
      if (!this.breastfeed_nexttime) {
        this.showAlertMessage("授乳欄の「預かり中予定時間」に関する内容を入力してください。");
        return;
      } else {
        // 形式 "時:分" => HH:mm
        this.interviewInfo.breastfeed_nexttime = moment(this.breastfeed_nexttime).format("HH:mm");
      }


      // requiredError: ミルクの種類
      if (!this.interviewInfo.breastfeed_type) {
        this.showAlertMessage("授乳欄の「種類」に関する内容を入力してください。");
        return;
      }

      if (this.interviewInfo.breastfeed_type === '園内の粉ミルク') {
        // 園内の粉ミルク にチェックがついたら
        // 飲む量(1回)
        if (!this.interviewInfo.breastfeed_drinkcc) {
          this.showAlertMessage("授乳欄の「飲む量」に関する内容を入力してください。");
          return;
        }
      } else if (this.interviewInfo.breastfeed_type === '持参の粉ミルク') {
        // 持参の粉ミルク にチェックがついたら
        // 飲む量(1回)
        if (!this.interviewInfo.breastfeed_drinkcc) {
          this.showAlertMessage("授乳欄の「飲む量」に関する内容を入力してください。");
          return;
        }

        // 持ち込む際の確認事項
        if (!this.interviewInfo.breastfeedMyMilkConfirmed001) {
          this.showAlertMessage("授乳欄の「持ち込む際の確認事項」に関する内容を入力してください。");
          return;
        }
        if (!this.interviewInfo.breastfeedMyMilkConfirmed002) {
          this.showAlertMessage("授乳欄の「持ち込む際の確認事項」に関する内容を入力してください。");
          return;
        }
        // お子様が持参の粉ミルクを飲めなかった場合の対応
        if (!this.interviewInfo.breastfeed_cannotdrink) {
          this.showAlertMessage("授乳欄の「お子様が持参の粉ミルクを飲めなかった場合の対応」に関する内容を入力してください。");
          return;
        }
      } else if (this.interviewInfo.breastfeed_type === '冷凍母乳') {
        // 冷凍母乳 にチェックがついたら

        if (!this.interviewInfo.breastfeedFrozenBreastMilkConfirmed001) {
          this.showAlertMessage("授乳欄の「冷凍母乳」に関する内容を入力してください。");
          return;
        }
        if (!this.interviewInfo.breastfeedFrozenBreastMilkConfirmed002) {
          this.showAlertMessage("授乳欄の「冷凍母乳」に関する内容を入力してください。");
          return;
        }
        if (!this.interviewInfo.breastfeedFrozenBreastMilkConfirmed003) {
          this.showAlertMessage("授乳欄の「冷凍母乳」に関する内容を入力してください。");
          return;
        }
        if (!this.interviewInfo.breastfeedFrozenBreastMilkConfirmed004) {
          this.showAlertMessage("授乳欄の「冷凍母乳」に関する内容を入力してください。");
          return;
        }
        // お子様が持参の粉ミルクを飲めなかった場合の対応
        if (!this.interviewInfo.breastfeed_cannotdrink) {
          this.showAlertMessage("授乳欄の「お子様が持参の粉ミルクを飲めなかった場合の対応」に関する内容を入力してください。");
          return;
        }
      }


    }

    // requiredError: 怪我
    if (!this.interviewInfo.injured) {
      this.showAlertMessage("「怪我」に関する内容を入力してください。");
      return;
    }

    // requiredError: お昼寝
    if (!this.interviewInfo.napped) {
      this.showAlertMessage("「お昼寝」に関する内容を入力してください。");
      return;
    }

    // requiredError: 与薬
    if (!this.interviewInfo.use_drug) {
      this.showAlertMessage("「与薬」に関する内容を入力してください。");
      return;
    } else if (this.interviewInfo.use_drug === "true") {
      // 与薬 薬剤処方日
      if (!this.drugPrescriptionDate) {
        this.showAlertMessage("与薬欄の「薬剤処方日」に関する内容を入力してください。");
        return;
      }
      // 与薬 医療機関名
      if (!this.interviewInfo.drug_hospital_name) {
        this.showAlertMessage("与薬欄の「医療機関名」に関する内容を入力してください。");
        return;
      }

      if (this.interviewInfo.drug_list) {
        for (const drug of this.interviewInfo.drug_list) {
          // 与薬 薬名
          if (!drug.name) {
            this.showAlertMessage("与薬欄の「薬名」に関する内容を入力してください。");
            return;
          }
          // 与薬 薬の種類
          if (!drug.what) {
            this.showAlertMessage("与薬欄の「薬の種類」に関する内容を入力してください。");
            return;
          }
          // 与薬 薬の種類
          if (drug.what === 'other' && !drug.what_other_description) {
            this.showAlertMessage("与薬欄の「薬の種類」に関する内容を入力してください。");
            return;
          }
          // 与薬 与薬方法
          if (!drug.how) {
            this.showAlertMessage("与薬欄の「与薬方法」に関する内容を入力してください。");
            return;
          }
          // 与薬 与薬方法
          if (drug.how === 'other' && !drug.how_other_description) {
            this.showAlertMessage("与薬欄の「与薬方法」に関する内容を入力してください。");
            return;
          }
        }
      }

      // 与薬 依頼日
      if (!this.drugUseRequestedDate) {
        this.showAlertMessage("与薬欄の「依頼日」に関する内容を入力してください。");
        return;
      }
      // 与薬 依頼者(保護者名)
      if (!this.interviewInfo.drug_use_requester_name) {
        this.showAlertMessage("与薬欄の「保護者名」に関する内容を入力してください。");
        return;
      }
    }

    if (this.isChangeNyuyokuKiboubox) {
      if (!this.interviewInfo.change_nyuyokukibou) {
        this.showAlertMessage("入浴欄の「入浴の希望有無」に関する内容を入力してください。");
        return;
      }
    }

    if (this.hasInvalidRequired()) {
      this.alert(
        this.alertController,
        "未入力の項目を確認してください。（" +
          this._el.querySelectorAll(".requiredError").length +
          "箇所）"
      );
      return;
    }
    // 問診票が登録されている場合、更新処理にする
    if (this.interviewId) {
      this.data["id"] = this.interviewId;
    } else {
      this.data["id"] = "";
    }

    // 薬剤処方日をYYYY-MM-DDの形式に変換する
    if (this.drugPrescriptionDate) {
      const date = new Date(this.drugPrescriptionDate);
      this.interviewInfo.drug_prescription_date = `${date.getFullYear()}/${(
        "0" +
        (date.getMonth() + 1)
      ).slice(-2)}/${("0" + date.getDate()).slice(-2)}`;
    } else {
      this.interviewInfo.drug_prescription_date = "";
    }
    if (this.drugUseRequestedDate) {
      const date = new Date(this.drugUseRequestedDate);
      this.interviewInfo.drug_use_requested_date = `${date.getFullYear()}/${(
        "0" +
        (date.getMonth() + 1)
      ).slice(-2)}/${("0" + date.getDate()).slice(-2)}`;
    } else {
     this.interviewInfo.drug_use_requested_date = "";
    }

    this.data["child"] = this.child; // 子どもデータ
    this.data["reserve"] = this.reserve; // 予約情報
    this.data["interviewInfo"] = this.interviewInfo; // 問診票情報を格納

    // 登録
    this.confirm(
      this.alertController,
      "入力された内容で問診票を送信します。よろしいですか？",
      () => {
        this.reserveAction.saveInterviewSheet(this.data).subscribe((data) => {
          this.toast(this.toastController, "問診票情報を保存しました。");
          // this.navCtrl.pop();
          this.isStaffConfirm = true;
        });
      }
    );
  }

  changeUseDrug() {
    // 与薬ありにした場合
    if (this.interviewInfo.use_drug == "true") {
      // 与薬の薬が0件の場合は、デフォルトで1件登録しておく
      if (
        !this.interviewInfo.drug_list ||
        this.interviewInfo.drug_list.length === 0
      ) {
        this.addDrugBox();
      }
    }
  }

  addDrugBox() {
    if (!this.interviewInfo.drug_list) {
      this.interviewInfo.drug_list = [];
    }
    this.interviewInfo.drug_list.push({
      name: "",
      what: "",
      what_other_description: "",
      when: "",
      when_other_description: "",
      how: "",
      how_other_description: "",
      external_description: "",
      description: "",
    });
  }
  deleteDrugBox(i) {
    this.interviewInfo.drug_list = this.interviewInfo.drug_list.filter(
      (data, index) => {
        return i !== index;
      }
    );
  }

  close() {
    // TODO: ご家族に入力頂いた後の画面は、共通の画面となるのでコンポーネント化すべき
    // 端末をご家族の方にお渡ししているため、パスワード認証をかけておく
    if (this.staffPassword === "8710") {
      this.viewController.dismiss();
    } else {
      alert("パスワードが異なります");
    }
  }

  // アレルギーの変更
  changeAllergyStatus() {
    if (!this.interviewInfo.is_change_allergy_status) {
      // 空にする
      this.interviewInfo.allergy_status = "";
      this.interviewInfo.change_allergy_text = "";
    }
  }

  isChangeRinyusyokuOkayuBox = "";
  changeRinyusyokuOkayuBox() {
    if (!this.isChangeRinyusyokuOkayuBox) {
      // 空にする
      this.interviewInfo.rinyusyoku_okayu = "";
    }
  }
  isChangeKeijyoYasaiBox = "";
  changeKeijyoYasaiBox() {
    if (!this.isChangeKeijyoYasaiBox) {
      // 空にする
      this.interviewInfo.keijyo_yasai = "";
      this.interviewInfo.rinyushoku_tabetakotoaru_shokuzai = [];
    }

  }

  isChangeNyuyokuKiboubox = "";
  changeNyuyokuKiboubox() {
    if (!this.isChangeNyuyokuKiboubox) {
      // 空にする
      this.interviewInfo.change_nyuyokukibou = "";
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/reserve/interview/edit-family/reserve-interview-edit-family.ts